import { render, staticRenderFns } from "./AtrativoCarrosel.vue?vue&type=template&id=3ac8a019"
import script from "./AtrativoCarrosel.vue?vue&type=script&lang=js"
export * from "./AtrativoCarrosel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports